import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase web config is not a secret (https://firebase.google.com/docs/projects/api-keys) —
// access is restricted by Firebase Security Rules / API key restrictions, not by hiding
// these values. Defaults below are this project's actual config; REACT_APP_FIREBASE_*
// env vars can override per-environment if ever needed.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyCNvaeCMjCQliXAfaWc-T-24e9gu63SIcA',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'thaathayya-illu.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'thaathayya-illu',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'thaathayya-illu.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '216773722364',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:216773722364:web:60c76cb97a2d23614d5779',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-45M8WF77P3',
};

export const firebaseApp = initializeApp(firebaseConfig);

// getAnalytics() throws in environments without cookie/IndexedDB support (private
// browsing, bots, some in-app browsers), so gate it behind isSupported() rather than
// letting an unsupported browser crash app boot.
export const analyticsPromise = isSupported().then((supported) =>
  supported ? getAnalytics(firebaseApp) : null
);
